/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Cta_OnlineInputs */

const en_wc_cta_online = /** @type {(inputs: Wc_Cta_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use WordCraft online`)
};

/**
* | output |
* | --- |
* | "Use WordCraft online" |
*
* @param {Wc_Cta_OnlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_cta_online = /** @type {((inputs?: Wc_Cta_OnlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Cta_OnlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_cta_online(inputs)
});
export { wc_cta_online as "wc.cta.online" }